<template>
  <page-toolbar :searchable="false" :sticky="false">
    <template #filters>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <date-picker
          :value="date"
          @input="$emit('update:date', $event)"
          single-date
          color="white"
        ></date-picker>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2" xl="2">
        <dropdown
          :value="filterType"
          @input="$emit('update:filterType', $event)"
          :items="menuTypeForFilter"
          :label="$t('menu_type')"
          item-text="text"
          item-value="value"
          color="white"
          hide-details
        ></dropdown>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <shift-picker
          v-model="selectedShifts"
          @input="$emit('update:selectedShifts', $event)"
          :items="shifts"
          multiple
          item-text="text"
          item-value="value"
          color="white"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2" xl="2">
        <dropdown
          :value="selectedSortingType"
          @input="$emit('update:selectedSortingType', $event)"
          :items="[
            { text: $t('id_pr'), val: 1 },
            { text: $t('align'), val: 2 },
          ]"
          :label="$t('sorting')"
          item-text="text"
          item-value="val"
          color="white"
          hide-details
        ></dropdown>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2" xl="2">
        <text-field
          v-model="searchValue"
          :label="$t('search')"
          :placeholder="$t('search')"
          clearable
          hide-details
          kind="search"
          color="white"
          append-icon="mdi-magnify"
        ></text-field>
      </v-col>
    </template>
  </page-toolbar>
</template>

<script>
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  name: "MenuFiltersBar",
  components: {
    PageToolbar,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    menuName: {
      type: String,
      default: "",
    },
    filterType: {
      type: String,
      default: "all",
    },
    search: {
      type: String,
      default: "",
    },
    menuTypes: {
      type: Array,
      default: () => [],
    },
    selectedShifts: {
      type: Array,
      default: () => [1, 2, 3, 4],
    },
  },
  data() {
    return {
      selectedSortingType: 1,
    };
  },
  computed: {
    shifts() {
      return [
        { text: this.$t("1st_shift"), value: 1 },
        { text: this.$t("2nd_shift"), value: 2 },
        { text: this.$t("3rd_shift"), value: 3 },
        { text: this.$t("4th_shift"), value: 4 },
      ];
    },
    searchValue: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit("update:search", value);
      },
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
    menuTypeForFilter() {
      return [
        {
          text: this.$t("all"),
          value: "all",
        },
        ...this.menuTypes.map((item) => ({
          ...item,
          text: this.$t(item.name),
          value: item.id,
        })),
      ];
    },
  },
  created() {
    this.initializeGuestMealType();
  },
  methods: {
    initializeGuestMealType() {
      if (this.restaurant.settings.lice_bez_ugovora) {
        this.menuTypes.push({ name: this.$t("for_guest"), val: "guest_meal" });
      }
    },
  },
};
</script>

<style scoped></style>
